// extracted by mini-css-extract-plugin
export default {"wrapper":"Px-z","viewport":"Qx-z","container":"Rx-z","slide":"Sx-z"};